import * as Yup from 'yup';
import { FormFields, FormKeys } from '../types';

export const initialFormValues: FormFields = {
    [FormKeys.PackName]: '',
    [FormKeys.Description]: '',
    [FormKeys.LabelName]: '',
    [FormKeys.PackGenre]: '',
    [FormKeys.PackSubgenre]: '',
    [FormKeys.Exclusivity]: '',
    [FormKeys.Lexicon]: '',
};

export const formSchema = Yup.object().shape({
    [FormKeys.PackName]: Yup.string().required('Required'),
    [FormKeys.Description]: Yup.string().required('Required'),
    [FormKeys.LabelName]: Yup.string().required('Required'),
    [FormKeys.PackGenre]: Yup.string().required('Required'),
});
